import { PageContent } from '@components/pages/styles'
import { PageContentHeader } from '@components/pages/page-content-header'
import { pageContentWidth } from '@components/pages/styles'

export { PageContentHeader, PageContent, pageContentWidth }
